import API from './API';

export default {

    findCulturePhases() {
        return API.get("/culture-phases")
    }

}
